export default __webpack_public_path__ + "static/media/mobile_newstab_banner.a791f12a.png";